import { CardResp } from "../Data/ApiTypes";

export interface PaymentMethodCardProps {
    card:          CardResp;
    className?:    string;
    activeCount?:  number;
}

function getCardLogo( cardBrand: string ) {
    switch( cardBrand ) {
        case "visa":       return "/img/card-logo-visa.svg";
        case "mastercard": return "/img/card-logo-mastercard.svg";
        case "amex":       return "/img/card-logo-american-express.svg";
        case "discover":   return "/img/card-logo-discover.png";
        default:           return null;
    }
}

export function PaymentMethodCard( { card, className = "", activeCount = 0 }: PaymentMethodCardProps ) {
    const expYear = card.expirationYear.toString().substring( 2 );
    const logo    = getCardLogo( card.brand );
    const isUsed  = activeCount > 0;

    return (
        <div
            className={`${className} d-flex flex-column p-3 rounded-3 bg-white w-100`}
            style={{
                minWidth: 170,
                minHeight: 110,
                border: "1px solid #e8e8e8",
                boxShadow: "0 1px 4px rgba(0,0,0,0.07)",
            }}
        >
            {/* Brand logo */}
            <div className="mb-2">
                {logo
                    ? <img src={logo} style={{ height: 22, objectFit: "contain" }} alt={card.brand} />
                    : <span className="fw-bold text-secondary" style={{ fontSize: "0.8rem", textTransform: "uppercase" }}>{card.brand}</span>}
            </div>

            {/* Last 4 */}
            <div className="fw-bold" style={{ fontSize: "0.95rem", letterSpacing: "0.03em" }}>
                •••• {card.last4Digits}
            </div>

            {/* Expiry + badge row */}
            <div className="d-flex align-items-center justify-content-between mt-auto pt-2">
                <span className="text-secondary" style={{ fontSize: "0.78rem" }}>
                    Exp {card.expirationMonth}/{expYear}
                </span>
                {isUsed ? (
                    <span
                        className="px-2 py-1 rounded-pill fw-semibold"
                        style={{ fontSize: "0.7rem", background: "#d1fae5", color: "#065f46" }}
                    >
                        {activeCount} active
                    </span>
                ) : (
                    <span
                        className="px-2 py-1 rounded-pill fw-semibold"
                        style={{ fontSize: "0.7rem", background: "#f1f1f1", color: "#888" }}
                    >
                        Unused
                    </span>
                )}
            </div>
        </div>
    );
}
